import { Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Papers from "@/pages/Papers";
import PaperDetail from "@/pages/PaperDetail";
import Try from "@/pages/Try";
import Admin from "@/pages/Admin";
import AdminCategories from "@/pages/AdminCategories";
import NotFound from "@/pages/NotFound";

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/papers" element={<Papers />} />
        <Route path="/papers/:slug" element={<PaperDetail />} />
        <Route path="/try" element={<Try />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/categories" element={<AdminCategories />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
